module.exports = __webpack_public_path__ + "static/media/calc.da749189.svg";